module.exports = __webpack_public_path__ + "static/media/2.66c7527c.svg";